import Divider from '@mui/material/Divider';
import FlatButton from '@mui/material/Button';
import PropTypes from 'prop-types';
import React, {
  Fragment,
  useCallback,
  useMemo,
} from 'react';
import { TransitionGroup } from 'react-transition-group';

import LoadingIndicator from 'components/LoadingIndicator';
import FadeTransition from 'components/transitions/Fade';
import useIsMobile from 'lib/useIsMobile';

const border = '1px solid rgba(0, 0, 0, 0.1)';
const Comments = ({ children, hasMore, loading, onLoadMore }) => {
  const mobile = useIsMobile();
  const marginLeft = useMemo(
    () => (mobile
      ? 8
      : 16),
    [mobile],
  );
  return (
    <Fragment>
      <TransitionGroup
        style={useMemo(
          () => ({
            borderLeft: border,
            marginLeft,
          }),
          [marginLeft],
        )}
      >
        {React.Children.map(
          children,
          useCallback(
            (child, idx) => (
              <FadeTransition key={`comment-${idx}`}>
                <Fragment>
                  <Divider />
                  {child}
                </Fragment>
              </FadeTransition>
            ),
            [],
          ),
        )}
      </TransitionGroup>
      {useMemo(
        () => loading && <LoadingIndicator />,
        [loading],
      )}
      {useMemo(
        () => !loading && hasMore && (
          <FlatButton
            disabled={loading}
            fullWidth
            onClick={onLoadMore}
            primary
            style={{
              borderTop: border,
              marginLeft,
            }}
          >
            Load More
          </FlatButton>
        ),
        [
          hasMore,
          loading,
          onLoadMore,
          marginLeft,
        ],
      )}
    </Fragment>
  );
};

Comments.propTypes = {
  children: PropTypes.node.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
};

export default Comments;
